import React from 'react'
import classNames from 'classnames'
import { Check, ExclamationWithCircle } from '../Svg'
import Text from '../Text'
import styles from './Alert.module.scss'

const DANGER = 'danger'
const SUCCESS = 'success'

const ALERT_TYPES = [DANGER, SUCCESS] as const
export type AlertTypes = typeof ALERT_TYPES[number]

export interface AlertProps {
  children: JSX.Element | JSX.Element[]
  type: AlertTypes
  className?: string
}

export interface PartOptions {
  message: JSX.Element | null
}

const Message = ({ children }) => {
  return (
    <Text color='white' size='l'>
      {children}
    </Text>
  )
}

const Alert = ({ type, className, children }: AlertProps) => {
  const parts: PartOptions = {
    message: null,
  }

  React.Children.forEach(children, child => {
    switch (child?.type) {
      case Message: {
        parts.message = child
        break
      }
      default:
        break
    }
  })

  const renderIcon = () => {
    switch (type) {
      case DANGER:
        return <ExclamationWithCircle />
      case SUCCESS:
        return <Check />
      default:
        return <ExclamationWithCircle />
    }
  }

  const alertClassName = classNames(
    styles.alert,
    styles[`color-${type}`],
    styles[`border-${type}`],
    className
  )

  return (
    <div className={alertClassName} role='alert'>
      <div className={styles.icon}>{renderIcon()}</div>
      {parts.message}
    </div>
  )
}

Alert.Message = Message

export default Alert
